import { useMemo } from 'react';
import { useMaterializedExpressionReferences } from '../../render/hooks/useMaterializedExpressionReferences.tsx';
import { useWatchReferences } from '../../render/hooks/useWatchReferences.tsx';
import { type IAsyncServiceInputConfig } from './useAsyncServiceFetch.ts';

export function useAsyncServiceVaribles(
  basePath: string,
  inputs: IAsyncServiceInputConfig | null | undefined,
) {
  const inputReferences = useMemo(() => Object.values(inputs ?? {}), [inputs]);

  const { references } = useMaterializedExpressionReferences(
    basePath,
    inputReferences,
  );

  const variables = useWatchReferences(references);

  return variables;
}
